import React from 'react';
import Form from '../elements/Form';
import '../css/pages/Contact.css';

function Contact() {

  return (
    <div id="contact" className="container-contact">
      <section className="section-form">
        <h1
          className="page-header"
        >
          Contato
        </h1>
        <Form />
      </section>
    </div>
  );
}

export default Contact;
